import { render, staticRenderFns } from "./DSCheckbox.vue?vue&type=template&id=8b55d12c&scoped=true&"
import script from "./DSCheckbox.vue?vue&type=script&lang=js&"
export * from "./DSCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./DSCheckbox.vue?vue&type=style&index=0&id=8b55d12c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b55d12c",
  null
  
)

export default component.exports